import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectSelectedMultiProperties } from "@/redux/slices/property";
import {
  listGprtRequests,
  listGprtRequestsAcrossProperties,
} from "@/pages/grouppricingrequests/ActionApis/GprtApis";
import { logError } from "@/utils/errorHandler";
import { featureFlags } from "@/config";

const FETCH_SIZE = 500;

/** Sidebar badge for GPRT: requests answered but not yet acknowledged/closed, scoped to the properties selected on the GPRT page. */
export const useGprtAnsweredRequestsCount = (): number => {
  const selectedProperties = useSelector(selectSelectedMultiProperties);
  const propertyKey = selectedProperties
    .map((p) => p.propertyId)
    .sort()
    .join(",");
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!featureFlags.groupPricingRequests) {
      setCount(0);
      return;
    }
    const propertyIds = propertyKey ? propertyKey.split(",") : [];
    if (propertyIds.length === 0) {
      setCount(0);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const params = { size: FETCH_SIZE, status: "ACK" as const };
        const res =
          propertyIds.length > 1
            ? await listGprtRequestsAcrossProperties(propertyIds, params)
            : await listGprtRequests(propertyIds[0], params);
        if (cancelled) return;
        if (res.hasMore) {
          logError(
            new Error(
              `GPRT answered count hit the ${FETCH_SIZE}-row fetch cap — count may be an undercount`
            ),
            "Sidebar: GPRT answered requests count may be an undercount"
          );
        }
        setCount(res.content.length);
      } catch (err: unknown) {
        if (!cancelled) {
          logError(err, "Sidebar: failed to load GPRT answered requests count");
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [propertyKey]);

  return count;
};
